import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { asset, assetCategory } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { QRCode } from "react-qrcode-logo";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import ImageViewer from "../../components/ImageViewer";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { HierarchyView } from "./hierarchy-view.js";
import { PermissionChecker } from "../../components/PermissionChecker/index.jsx";
import SearchableFilter from "../../components/SearchableFilter";
import DebounceInput from "../../components/form/HorizontalDebounceInput";
import AssetQRTab from "./tabs/AssetQRTab.jsx";

function AssetList() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1,take:10,totalData:1,search:"" });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([])
  const [viewType, setViewType] = useState('list');
  const [activeTab, setActiveTab] = useState('list'); // 'list' | 'qr'
  const [qrPrintAsset, setQrPrintAsset] = useState(null); // asset to preview in QR modal

  async function getData() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await asset.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data && data.results) {
          data.results.forEach((d) => {
            const locationNameArr = [];
            generateLocationToArray(d.location, locationNameArr);
            d.location_arr = locationNameArr.reverse();
          });
          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData:data.totalData
          }))
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  const getCategory = async () => {

    const res = await assetCategory.list()
    if (res.ok) {
      const body = await res.json()
      setCategories(body.data)
    }


  }


  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  /** Traverse location tree upward to find root (customer/company name) */
  function getRootLocationName(location) {
    if (!location) return "";
    let node = location;
    while (node.parent_location) {
      node = node.parent_location;
    }
    return node.location_name || "";
  }

  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">
                <ImageViewer src={data?.asset_image}></ImageViewer>
              </div>
              <div className="col-md-9">
                <div>
                  Asset Name : <b>{data?.asset_name}</b>
                </div>
                <hr />
                <div>Description: {data?.description}</div>
                <div>QR Code</div>
                <div style={{ display: "block" }}>
                  <QRCode value={data?.barcode} logoImage={"/cmms/logo.png"} />
                </div>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => navigate("/assets/detail/" + data.id)}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>
                <button
                  onClick={() => navigate("/assets/edit/" + data.id)}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-warning"
                >
                  <i className="fa fa-edit"></i> Edit Asset
                </button>

                <button
                  onClick={() => navigate("/assets/edit/" + data.id+"?transfer=true")}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-primary"
                >
                  <i className="fa fa-exchange"></i> Transfer Asset
                </button>

                {/* Print QR button */}
                <button
                  onClick={() => setQrPrintAsset(data)}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-success"
                >
                  <i className="bi bi-qr-code"></i> Print QR
                </button>

                <PermissionChecker permissions={["delete asset"]} hideIfNotAllowed>
                <button
                  onClick={() => showConfirmationDlg(data)}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-danger"
                >
                  <i className="fa fa-edit"></i> Delete Asset
                  </button>
                  </PermissionChecker>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  /** Modal for single-asset QR preview + print */
  function QRPrintModal({ asset: item, onClose }) {
    if (!item) return null;

    const customerName = getRootLocationName(item.location)
      || item.customer?.customer_name
      || item.customer?.name
      || "";
    const assetName = item.asset_name || "-";
    const barcode = item.barcode || item.id;

    function handlePrint() {
      window.print();
    }

    return (
      <>
        {/* Backdrop */}
        <div
          onClick={onClose}
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.65)",
            zIndex: 1050,
            backdropFilter: "blur(3px)",
          }}
        />

        {/* Modal box */}
        <div
          style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1051,
            background: "#1e2227",
            borderRadius: "12px",
            boxShadow: "0 24px 64px rgba(0,0,0,0.6)",
            padding: "24px",
            width: "480px",
            maxWidth: "94vw",
          }}
        >
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "18px" }}>
            <span style={{ fontWeight: 700, fontSize: "15px", color: "#fff", display: "flex", alignItems: "center", gap: "8px" }}>
              <i className="bi bi-qr-code" style={{ fontSize: "18px", color: "var(--bs-theme, #4fc3f7)" }} />
              QR Print Preview
            </span>
            <button
              onClick={onClose}
              style={{ background: "none", border: "none", color: "#aaa", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
            >
              ×
            </button>
          </div>

          {/* Sticker preview — white background, matches AssetQRTab layout */}
          <div
            id="qr-single-print-area"
            style={{
              background: "#ffffff",
              borderRadius: "6px",
              padding: "16px",
              marginBottom: "20px",
            }}
          >
            <div style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "12px 14px",
              background: "#fff",
              gap: "0",
            }}>
              {/* QR Code */}
              <div style={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", width: "100px", height: "100px" }}>
                <QRCode
                  value={String(barcode)}
                  logoImage="/cmms/logo.png"
                  size={96}
                  quietZone={2}
                  logoWidth={22}
                  logoHeight={22}
                  removeQrCodeBehindLogo
                  qrStyle="dots"
                  eyeRadius={3}
                />
              </div>

              {/* Vertical divider */}
              <div style={{ width: "1px", background: "#ddd", alignSelf: "stretch", margin: "0 14px", flexShrink: 0 }} />

              {/* Text info */}
              <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", gap: "4px", paddingTop: "4px" }}>
                {customerName && (
                  <div style={{ fontSize: "14px", fontWeight: 700, color: "#333", textTransform: "uppercase", letterSpacing: "0.3px", wordBreak: "break-word" }}>
                    {customerName}
                  </div>
                )}
                <div style={{ fontSize: "13px", fontWeight: 400, color: "#111", lineHeight: 1.4, wordBreak: "break-word" }}>
                  {assetName}
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            <button onClick={onClose} className="btn btn-outline-secondary">
              Close
            </button>
            <button onClick={handlePrint} className="btn btn-outline-success">
              <i className="bi bi-printer me-1" /> Print
            </button>
          </div>
        </div>

        {/* Print-only styles */}
        <style>{`
          @media print {
            body > * { visibility: hidden !important; }
            #qr-single-print-area,
            #qr-single-print-area * { visibility: visible !important; }
            #qr-single-print-area {
              position: fixed !important;
              top: 0; left: 0;
              width: 100%;
              padding: 20mm 24mm !important;
              box-sizing: border-box;
            }
          }
        `}</style>
      </>
    );
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function openChangeStatus(value) {
    setChangeStatus(value);
  }



  async function deleteData() {
    try {
      const response = await asset.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This asset has been deleted");

          setDeleteRow(null);
          getData()
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  const columns = [
    {
      name: "Asset Name",
      selector: (row) => row.asset_name,
      minWidth: "150px",
    },
    {
      name: "Asset model",
      selector: (row) => row.asset_model,
    },
    {
      name: "Serial Number",
      selector: (row) => row.serial_number,
    },

    ...generateLocationWording().map((w, i) => ({
      name: w,
      grow: 1,
      wrap:true,
      selector: (row) => printLocation(row.location_arr[i]),
    })),
    {
      name: "Category",
      selector: (row) => row.category?.name,
    },
  ];

  const handleChangeLocationFilter = (location) => {
    setQuery((prev) => ({
      ...prev,
      page:1,
      location_id: location ? location.id : "",
    }));
  };

  const handleChangeCategory = (id) => {
      if(!id){
          setQuery((prev) => ({
              ...prev,
              page:1,
              category_id: "",
          }));
      }else{
          setQuery((prev) => ({
              ...prev,
              page:1,
              category_id: id,
          }));
      }
  };
    const handleChangeKeyword = (e) => {
        setQuery((prev) => ({
            ...prev,
            page: 1,
            search: e.target.value,
        }));
    };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page,query.take,query.location_id,query.category_id, query.search]);

  useEffect(() => {

getCategory()
  },[])


  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">ASSET</a>
            </li>
            <li className="breadcrumb-item active">ASSET LIST</li>
          </ul>

          <h1 className="page-header">Asset List</h1>

          {/* ── Tab Bar ── */}
          <div style={{
            display: 'flex',
            gap: '4px',
            borderBottom: '2px solid rgba(255,255,255,0.08)',
            marginBottom: '20px',
          }}>
            {[
              { key: 'list', icon: 'bi bi-card-list', label: 'Asset List' },
              { key: 'qr',   icon: 'bi bi-qr-code',   label: 'Asset QR List' },
            ].map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveTab(tab.key)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '7px',
                  padding: '9px 20px',
                  border: 'none',
                  borderRadius: '6px 6px 0 0',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: '13.5px',
                  letterSpacing: '0.2px',
                  transition: 'background 0.18s, color 0.18s',
                  background: activeTab === tab.key
                    ? 'var(--bs-theme, #4fc3f7)'
                    : 'transparent',
                  color: activeTab === tab.key ? '#fff' : 'rgba(255,255,255,0.55)',
                  borderBottom: activeTab === tab.key
                    ? '2px solid var(--bs-theme, #4fc3f7)'
                    : '2px solid transparent',
                  marginBottom: '-2px',
                }}
              >
                <i className={tab.icon} style={{ fontSize: '15px' }} />
                {tab.label}
              </button>
            ))}
          </div>

          {/* ── Asset List Tab ── */}
          {activeTab === 'list' && (
            <div id="datatable" className="mb-5">
              <div className="row mb-2 justify-content-sm-end">

                <div className="col-sm-2  mb-2 mb-sm-0 btn-group" role="group" aria-label="Basic example" style={{marginRight:10}}>
                  <OverlayTrigger placement="top" overlay={<Tooltip >
    List View
                </Tooltip>}><button onClick={() => setViewType('list')} type="button" className={`btn ${viewType == 'list' ? 'btn-theme' : 'btn-outline-theme'}`}><i className="bi bi-list"></i></button></OverlayTrigger>

                  <OverlayTrigger placement="top" overlay={<Tooltip >
                  Location View
                </Tooltip>}><button onClick={() => setViewType('hierarchy')} type="button" className={`btn ${viewType == 'hierarchy' ? 'btn-theme' : 'btn-outline-theme'}`}><i className="bi bi-buildings-fill"></i></button></OverlayTrigger>

                </div>

                <div className="col-sm-3 mb-2 mb-sm-0">
                  <DebounceInput name="keyword" placeholder={'Search Asset name'} showDebounceIndicator delay={1000} onchange={handleChangeKeyword} />
                </div>
                <div className="col-sm-3 mb-2 mb-sm-0">
                  <LocationFilter onChange={handleChangeLocationFilter} />
                </div>
                <div className="col-sm-3 mb-2 mb-sm-0">
                  <div style={{zIndex:11, position:"relative"}}>
                    <SearchableFilter label={"Category"}
                      onChange={(e) => { handleChangeCategory(e?.value); }}
                      list={categories.map((i) => ({ value: i.id, label: i.name }))}
                    />
                  </div>
                </div>
                <div className="col-sm-3 mb-2 mb-sm-0">
                  <button
                    onClick={() => { navigate("/assets/add"); }}
                    className="btn btn-outline-theme w-100"
                  >
                    Add Asset <i className="bi bi-plus"></i>
                  </button>
                </div>
              </div>

              {viewType == 'list' && <div className="row">
                <div className="col-md-12">
                  <Card>
                    <CardBody>
                      <DataTable
                        progressPending={loading}
                        pointerOnHover
                        expandOnRowClicked
                        expandableRowsHideExpander
                        highlightOnHover
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        onChangeRowsPerPage={(row) => setQuery((prev) => ({ ...prev, page: 1, take: row }))}
                        paginationTotalRows={query.totalData}
                        onChangePage={(page) => setQuery((prev) => ({ ...prev, page: page }))}
                        paginationDefaultPage={query.page}
                      />
                    </CardBody>
                  </Card>
                </div>
              </div>}

              {viewType == 'hierarchy' && <HierarchyView queryParam={query} />}
            </div>
          )}

          {/* ── Asset QR Tab ── */}
          {activeTab === 'qr' && (
            <AssetQRTab categories={categories} />
          )}
        </div>
      </div>

      {/* QR Print Modal */}
      <QRPrintModal asset={qrPrintAsset} onClose={() => setQrPrintAsset(null)} />

      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Asset"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteData}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this Asset{" "}
            <strong>{deleteRow.name}</strong> ?
          </p>
        </ConfirmationDlg>
      )}

    </div>
  );
}

export default AssetList;
